import React, { useEffect, useState, useContext } from "react";
import MaterialTable from "material-table";
import AuthContext from "context/autentication/authContext";
import { useSnackbar } from "notistack";
import Titulo2 from "components/Dialog/Titulo2";
import clienteAxios from "../../../service/axios";
import Dialogs from "components/Dialog/Dialogs";
import { Role } from "types/roles";
import AlertaInfo from "./AlertaInfo";
import { MdVisibility } from "react-icons/md";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { ALERT_STATUS } from "types/alertadispositivo/index";


const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);





export default function TablaPolicial({ logs, refresh }) {
  const [open, setOpen] = React.useState(false);

  const [option, setOption] = useState("");
  const [index, setIndex] = useState();
  const authContext = useContext(AuthContext);
  const { rol } = authContext;
  const { enqueueSnackbar } = useSnackbar();

  const [lista, setLista] = useState([]);

  const showCallback = (x) => {
    if (x === 200) {
      enqueueSnackbar("Marcada con exito!", { variant: "success" });
    } else {
      enqueueSnackbar("Ocurrio un error!", { variant: "error" });
    }
  };
  const ordenarDatos = (data) => {
    //console.log(data);
    const resultado = data.map((x, index) => {
      return {
        fecha: x.auditoriaGeneracion.split("T", 2)[0],
        hora: x.auditoriaGeneracion.split("T", 2)[1].split(".", 2)[0],
        estado: x.estado,
        mensajeAlerta: x.data ? x.data : null,
        dispositivo: x.dispositivoId,
        index: index,
        original: x,
      };
    });

    return resultado;
  };

  const sendRequest = async (log, descargo) => {
    let resultado = "";
    let temp = "";
    resultado = await clienteAxios.put(`/alertas-dispositivos/${log.id}`, {
      descargo: descargo,
      estado: log.estado
    });
    if (temp.data) {
      resultado = temp.data.status;
    }
    return resultado;
  };

  const markAndRefresh = (index, descargo) => {
    const esPolicia = rol === Role.Supervisor || rol === Role.Super;
    const esUser =
      rol === Role.Admin || rol === Role.Soporte || rol === Role.Operador;
    const array = lista;
    const temp = array[index];
    const query = temp.original;
    if (esPolicia) {
      if (temp.estado === ALERT_STATUS.NOVISTA) {
        temp.estado = ALERT_STATUS.VISTAPOLICIA;
        query.estado = ALERT_STATUS.VISTAPOLICIA;
      }
      if (temp.estado === ALERT_STATUS.VISTAUSER) {
        temp.estado = ALERT_STATUS.VISTA;
        query.estado = ALERT_STATUS.VISTA;
      }
    }
    if (esUser) {
      if (temp.estado === ALERT_STATUS.NOVISTA) {
        temp.estado = ALERT_STATUS.VISTAUSER;
        query.estado = ALERT_STATUS.VISTAUSER;
      }
      if (temp.estado === ALERT_STATUS.VISTAPOLICIA) {
        temp.estado = ALERT_STATUS.VISTA;
        query.estado = ALERT_STATUS.VISTA;
      }
    }
    query.descargo = descargo;
    temp.original = query;
    array[index] = temp;
    const a = array;
    const i = index;
    sendRequest(query, descargo).then((value) => {
      showCallback(value.status);
      refresh();
      handleClose();
    });
  };
  useEffect(() => {
    setLista(ordenarDatos(logs));
  }, []);
  const handleClose = () => {
    setIndex();
    setOpen(false);
  };
  const openDescargo = (i) => {
    setIndex(i);
    setOption("descargo-policial");
    setOpen(true);
  };
  return (
    <div style={{ minHeight: "100%", maxHeight: "100%" }}>
      {option === "descargo-policial" && (
        <Dialogs
          rol={rol}
          lista={lista}
          open={open}
          handleClose={handleClose}
          index={index}
          disable={markAndRefresh}
          titulo={"Descargo"}
          option={"descargo-policial"}
          init={refresh}
          setOpen={setOpen}
        />
      )}
      <MaterialTable
        title={<Titulo2 titulo={" "} />}
        options={{
          search: false,
          exportButton: false,
          actionsColumnIndex: -1,
          maxBodyHeight: "47vh",
          minBodyHeight: "47vh",
          pageSize: 20,
          pageSizeOptions: [20, 50, 100],
        }}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsSelect: "filas",
            firstTooltip: "Primer Pág",
            lastTooltip: "Última Pág",
            nextTooltip: "Prox Pág",
            previousTooltip: "Anterior Pág",
          },
          toolbar: {},
          header: {
            actions: <p style={{width:"150px"}}>Marcar como vista</p>
          },
          body: {
            emptyDataSourceMessage: " Sus dispositivos no han registrado alertas",
          },
        }}
        columns={[
          //{ title: 'Cliente', field: 'cliente', render: rowData => obtenerNombreCliente(rowData.cliente) },
          { title: "Fecha", field: "fecha" },
          { title: "Hora", field: "hora" },
          {
            title: "Mensaje",
            field: "mensajeAlerta",
            render: (rowData) =>
              rowData.mensajeAlerta ? (
                <LightTooltip
                  title={
                    <p
                      style={{
                        fontSize: "12px",
                        minWidth: 70,
                        textAlign: "center",
                      }}
                    >
                      {rowData.mensajeAlerta}
                    </p>
                  }
                >
                  <div>
                    <AlertaInfo />
                  </div>
                </LightTooltip>
              ) : null,
          },

          //{ title: 'Nombre', field: 'notificaciones' },
        ]}
        data={lista}
        editable={[]}
        actions={[
          (rowData) => ({
            icon: () =>
              rowData.estado !== ALERT_STATUS.VISTA && rowData.estado !== ALERT_STATUS.VISTAUSER && rowData.estado !== ALERT_STATUS.VISTAPOLICIA ? (
                <MdVisibility style={{ color: "#DF2E2E"}} />
              ) : (
                <MdVisibility />
              ),
            tooltip: "Marcar como vista ", //+rowData.estado,
            onClick: () => markAndRefresh(rowData.index),
          }),
        ]}
      />
      <div></div>
    </div>
  );
}
